jQuery(document).ready(function () {
  // Main Slick Slider
  jQuery(".slick-slider-main-section").slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  });

  // Partner Logos Slider
  jQuery(".slick-partner-logos-section").slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // Get the width of the page
  var pageWidth = jQuery(window).width();
  // // Set the initial position to the end
  jQuery(".marque-left marquee ul").css("marque-left", pageWidth + "px");
  jQuery(".marque-right marquee ul").css("margin-left", "-" + pageWidth + "px");

  // FAQ Accordian Section
  jQuery(".accordion-item").each(function (index) {
    var incrementedValue = index + 1; // No padding, just incrementing
    jQuery(this).css("--dynamic-content", `"${incrementedValue}"`);
  });
});

// jQuery(document).ready(function ($) {
//     // Initialize the Slick Slider (Vertical)
//     $('.perfect-fit-main-slider').slick({
//         vertical: true,  // Enable vertical sliding
//         verticalSwiping: true, // Enable vertical swipe
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         dots: true,
//         arrows: false,
//         swipe: false,
//         infinite: false, // Disable infinite scroll
//     });

//     // Sync the services list with the active slide
//     $('.perfect-fit-main-slider').on('afterChange', function(event, slick, currentSlide) {
//         // Hide all service lists
//         $('.perfect-fit-services-list-wrap > div').hide();

//         // Show the corresponding service list for the active slide
//         var activeSlideIndex = currentSlide + 1; // Slick slider uses zero-based index, so we add 1
//         $('#perfect-fit-wrap-' + activeSlideIndex).show();
//     });

//     // Initially hide all service lists except the first one
//     $('.perfect-fit-services-list-wrap > div').hide();
//     $('#perfect-fit-wrap-1').show(); // Show the first one by default

//     // Variables for scroll behavior
//     var isScrolling = false; // Flag to prevent multiple triggers while scrolling fast
//     var sliderSection = $('.perfect-fit-main-slider').closest('section'); // Get the parent section of the slider
//     var isSliderInView = false; // Flag to check if the slider is in view

//     // Intersection Observer to detect when the slider section enters the viewport
//     var observer = new IntersectionObserver(function (entries, observer) {
//         entries.forEach(function (entry) {
//             if (entry.isIntersecting) {
//                 isSliderInView = true; // Slider section is in view
//             } else {
//                 isSliderInView = false; // Slider section is out of view
//             }
//         });
//     }, { threshold: 0.9 }); // Trigger when 50% of the section is in the viewport

//     // Observe the slider section
//     observer.observe(sliderSection[0]);

//     // Track the previous scroll position
//     var prevScroll = 0;

//     // Page scroll event for controlling the slider
//     $(window).on('scroll', function () {
//         if (!isSliderInView || isScrolling) return; // Only proceed if the slider is in view and no rapid scrolling

//         isScrolling = true; // Set the flag to prevent rapid scrolling

//         var currentScroll = $(this).scrollTop(); // Current scroll position of the page
//         var sliderHeight = $('.perfect-fit-main-slider').outerHeight(); // Height of the slider

//         // Check if we are scrolling down or up
//         if (currentScroll > prevScroll) {
//             // Scroll Down - Move to the next slide
//             $('.perfect-fit-main-slider').slick('slickNext');
//         } else if (currentScroll < prevScroll) {
//             // Scroll Up - Move to the previous slide
//             $('.perfect-fit-main-slider').slick('slickPrev');
//         }

//         prevScroll = currentScroll; // Update the previous scroll position

//         // Timeout to reset the scrolling flag (to allow smooth scrolling)
//         setTimeout(function () {
//             isScrolling = false;
//         }); // Adjust this time for smoother or faster scrolling
//     });

// });


jQuery(document).ready(function () {
let product_slides = document.querySelectorAll('#product-preview .images-wrapper .product-images');
    let slide_height = product_slides.item(0).offsetHeight;

    let active_slide;

    // Calculate which slide is active initially
    let dist_to_first_slide = window.pageYOffset + product_slides.item(0).getBoundingClientRect().top;
    if (window.pageYOffset <= dist_to_first_slide + slide_height / 2) {
      active_slide = 0;
    } else {
      active_slide = Math.floor((window.pageYOffset - dist_to_first_slide) / (slide_height / 2));
    }

    let dist_to_active_slide = window.pageYOffset + product_slides.item(active_slide).getBoundingClientRect().top;

    // On resize re-calculate distances
    window.addEventListener(
      'resize',
      () => {
        slide_height = product_slides.item(0).offsetHeight;

        dist_to_active_slide = window.pageYOffset + product_slides.item(active_slide).getBoundingClientRect().top;
      },
      true
    );

    document.addEventListener('scroll', (event) => {
      // Switch active product slide up or down so
      // we know which color to use, text to use, and slide dot to be on
      if (window.pageYOffset - dist_to_active_slide >= slide_height / 2 && active_slide < product_slides.length - 1) {
        active_slide += 1;
        dist_to_active_slide = window.pageYOffset + product_slides.item(active_slide).getBoundingClientRect().top;

        change_slide(active_slide);
      } else if (dist_to_active_slide - window.pageYOffset >= slide_height / 2 && active_slide >= 1) {
        active_slide -= 1;
        dist_to_active_slide = window.pageYOffset + product_slides.item(active_slide).getBoundingClientRect().top;

        change_slide(active_slide);
      }
    });

    function change_slide(active_slide) {
      let product_infos = document.querySelectorAll('#product-preview .info-wrapper .product-info');

      // Change the active product info
      product_infos.forEach((el, index) => {
        if (index == active_slide) {
          setTimeout(() => {
            el.style.display = 'flex';
            setTimeout(() => {
              el.style.opacity = '1';
            }, 10);
          }, 500);
        } else if (el.style.display == 'flex') {
          el.style.opacity = '0';
          setTimeout(() => {
            el.style.display = 'none';
          }, 500);
        }
      });

      // Change the circles color
      let color_circles = document.querySelectorAll('#product-preview .circle-wrapper .color-circle');
      color_circles.item(0).style['background-color'] = color_circles.item(active_slide + 1).style['background-color'];

      document.querySelectorAll('#product-preview .info-wrapper .nav-dots-wrapper .nav-dot').forEach((el, index) => {
        if (index == active_slide) {
          el.style['background-color'] = '#1f1209';
        } else {
          el.style['background-color'] = 'unset';
        }
      });
    }

    // Add delay to fix double showing issue
    setTimeout(() => {
      change_slide(active_slide);
    }, 100);


jQuery(window)
  .scroll(function () {
    // selectors
    var $window = $(window),
      $body = $("body"),
      $panel = $(".perfect-fit-main-section1");

    // Change 33% earlier than scroll position so colour is there when you arrive.
    var scroll = $window.scrollTop() + $window.height() / 3;

    $(".perfect-fit-main-section1").removeClass("active");

    $panel.each(function () {
      var $this = $(this);
      if (
        $this.position().top <= scroll &&
        $this.position().top + $this.height() > scroll
      ) {
        $this.addClass("active");
      }
    });
  })
  .scroll();
  });
jQuery(document).ready(function () {
  // Show reviews when the CLIENT REVIEWS tab or accordion button is clicked
  jQuery(".product-review-btn").on("click", function () {
    productReview();
  });

  // Hide reviews when switching to other tabs
  jQuery("#tabs .nav-link").on("show.bs.tab", function (e) {
    if (e.target.id !== "tab-C") {
      hideProductReview();
    }
  });

  // Handle accordion button click to show reviews
  jQuery(".accordion-button.product-review-btn").on("click", function () {
    jQuery("#tab-C").trigger("click"); // Simulate tab click for consistency
  });

  // Hide reviews when any other accordion item is expanded
  jQuery(".accordion-button").on("click", function () {
    if (!$(this).hasClass("product-review-btn")) {
      hideProductReview();
    }
  });

  // Function to show the reviews section
  function productReview() {
    document.getElementById("judgeme_product_reviews").style.display = "block";
  }

  // Function to hide the reviews section
  function hideProductReview() {
    document.getElementById("judgeme_product_reviews").style.display = "none";
  }

  /* Category list Slider */
  jQuery(".category-slider").slick({
    infinite: true,
    slidesToShow: 8,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: '<a href="javascript:void(0);" class="slick-prev"><span class="cleaning-service-prev-btn font-w500 h3"> <svg width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.40571 7.70832C4.44916 7.57416 4.54054 7.47107 4.62818 7.36496C6.04235 5.66104 8.44674 3.97834 9.7186 2.26533C9.82271 2.12435 9.94106 1.9864 10.0145 1.82495C10.6481 0.436349 9.00851 -0.605103 7.9329 0.400724C5.70903 2.97631 2.58931 5.32981 0.472541 7.93495C-0.0338044 8.558 -0.20608 9.13558 0.321989 9.83215L8.11417 17.7128C9.28042 18.6087 10.7598 17.2352 9.90661 15.9747L4.51732 10.437L4.59297 10.2854L21.8207 10.2854C22.3503 10.2854 22.9188 9.48197 22.9091 8.96276C22.8986 8.37154 22.3383 7.70831 21.7458 7.70831L4.40571 7.70832Z" fill="#333333"/></svg></span></a>',
    nextArrow: '<a href="javascript:void(0);" class="slick-next"><span class="cleaning-service-next-btn font-w500 h3"> <svg width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.5035 7.70832C18.46 7.57416 18.3686 7.47107 18.281 7.36496C16.8668 5.66104 14.4624 3.97834 13.1906 2.26533C13.0865 2.12435 12.9681 1.9864 12.8947 1.82495C12.261 0.436349 13.9007 -0.605103 14.9763 0.400724C17.2002 2.97631 20.3199 5.32981 22.4366 7.93495C22.943 8.558 23.1153 9.13558 22.5872 9.83215L14.795 17.7128C13.6288 18.6087 12.1494 17.2352 13.0026 15.9747L18.3919 10.437L18.3162 10.2854L1.08847 10.2854C0.5589 10.2854 -0.00961573 9.48197 0.000121783 8.96276C0.0106083 8.37154 0.570885 7.70831 1.16337 7.70831L18.5035 7.70832Z" fill="#333333"/></svg></span></a>',
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
  });
});

jQuery(document).ready(function () {
  document.addEventListener("DOMContentLoaded", function () {
    document
      .querySelectorAll(".sidebar-menu li a")
      .forEach(function (menuItem) {
        menuItem.addEventListener("click", function (event) {
          let subMenu = this.nextElementSibling;
          if (subMenu && subMenu.tagName === "UL") {
            event.preventDefault(); // Prevent navigation if clicking a parent menu
            subMenu.classList.toggle("active");
            subMenu.style.display =
              subMenu.style.display === "block" ? "none" : "block";
          }
        });
      });
  });

  // document.querySelectorAll(".menu-item-1").forEach(function (menuItem) {
  //   let toggleButton = menuItem.querySelector(".side-menu-toggle");
  //   let menuLink = menuItem.querySelector(".menu-link-1");
  //   let subMenu = menuItem.querySelector(".menu-level-2");

  //   if (subMenu) {
  //     let firstClick = false; // Track first click on menu link

  //     menuLink.addEventListener("click", function (event) {
  //       if (firstClick) {
  //         event.preventDefault(); // Prevent navigation on first click
  //         subMenu.classList.add("active");
  //         subMenu.style.display = "block";

  //         if (toggleButton) {
  //           toggleButton.textContent = "−";
  //         }

  //         firstClick = true; // Mark the first click
  //       } else {
  //         // On second click, allow navigation
  //         window.location.href = menuLink.href;
  //       }
  //     });

  //     if (toggleButton) {
  //       toggleButton.addEventListener("click", function (event) {
  //         event.preventDefault();
  //         subMenu.classList.toggle("active");
  //         subMenu.style.display = subMenu.classList.contains("active")
  //           ? "block"
  //           : "none";
  //         toggleButton.textContent = subMenu.classList.contains("active")
  //           ? "−"
  //           : "+";
  //       });
  //     }
  //   } else {
  //     // If there's no submenu, let the link work normally
  //     menuLink.addEventListener("click", function () {
  //       window.location.href = menuLink.href;
  //     });
  //   }
  // });


  document.querySelectorAll(".menu-item-1").forEach(function (menuItem) {
  let toggleButton = menuItem.querySelector(".side-menu-toggle");
  let menuLink = menuItem.querySelector(".menu-link-1");
  let subMenu = menuItem.querySelector(".menu-level-2");

  if (subMenu) {
    let firstClick = false; // Track first click on menu link

    menuLink.addEventListener("click", function (event) {
      if (!firstClick) {
        event.preventDefault(); // Prevent navigation on first click
        subMenu.classList.add("active");
        subMenu.style.display = "block";

        if (toggleButton) {
          toggleButton.classList.add("active"); // Add active to toggle button
          toggleButton.textContent = "−";
        }

        firstClick = true; // Mark the first click
      } else {
        // On second click, allow navigation
        window.location.href = menuLink.href;
      }
    });

    if (toggleButton) {
      toggleButton.addEventListener("click", function (event) {
        event.preventDefault();
        subMenu.classList.toggle("active");
        subMenu.style.display = subMenu.classList.contains("active")
          ? "block"
          : "none";

        // Toggle 'active' class on toggleButton
        toggleButton.classList.toggle("active");
        toggleButton.textContent = subMenu.classList.contains("active")
          ? "−"
          : "+";
      });
    }
  } else {
    // If there's no submenu, let the link work normally
    menuLink.addEventListener("click", function () {
      window.location.href = menuLink.href;
    });
  }
});

});

jQuery(document).ready(function ($) {
  $("#FacetFiltersForm .icon-caret").replaceWith(`
        <svg class="icon icon-caret" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.69229 4.35416C9.66953 4.28708 9.62167 4.23554 9.57576 4.18248C8.835 3.33052 7.57556 2.48917 6.90935 1.63267C6.85481 1.56217 6.79282 1.4932 6.75437 1.41248C6.42244 0.718174 7.2813 0.197449 7.84471 0.700362C9.0096 1.98815 10.6437 3.1649 11.7525 4.46748C12.0177 4.779 12.108 5.06779 11.8314 5.41608L7.74976 9.35638C7.13887 9.80434 6.36398 9.11762 6.81087 8.48737L9.63383 5.71851L9.5942 5.64271L0.570148 5.64271C0.292757 5.64271 -0.00503677 5.24098 6.38283e-05 4.98138C0.00555678 4.68577 0.299035 4.35416 0.609384 4.35416L9.69229 4.35416Z"/>
        </svg>
    `);
});
jQuery(document).ready(function ($) {
  $(".facets__disclosure-vertical").attr("open", "");
  
});


document.addEventListener("DOMContentLoaded", function () {
  const parentDiv = document.querySelector(".collection-hero__description"); // Select the parent div
  if (!parentDiv) return; // Stop if parent div not found

  const children = Array.from(parentDiv.children); // Get all child nodes as an array
  const visibleCount = 3; // Number of child nodes to show by default

  // Check if there are enough child elements to need "Read More"
  if (children.length === 0 || children.length <= visibleCount) {
    // Hide the button if no content or 3 or fewer items
    return;
  }

  // Initially show only the first 3 child elements
  children.forEach((child, index) => {
    if (index < visibleCount) {
      child.classList.add("visible"); // Show first 3 children
    } else {
      child.style.display = "none"; // Hide the rest initially
    }
  });

  // Create the "Read More" button dynamically
  const toggleButton = document.createElement("button");
  toggleButton.textContent = "Read More";
  toggleButton.className = "toggle-btn";

  // Append the button after the parent div
  parentDiv.insertAdjacentElement("afterend", toggleButton);

  // Add click event to the button
  toggleButton.addEventListener("click", function () {
    if (toggleButton.textContent === "Read More") {
      // Show all child elements
      children.forEach(child => {
        child.style.display = "block"; // Show all items
        child.classList.add("visible");
      });
      toggleButton.textContent = "Read Less"; // Change button text to "Read Less"
    } else {
      // Show only the first 3 child elements
      children.forEach((child, index) => {
        if (index < visibleCount) {
          child.style.display = "block"; // Keep first 3 visible
        } else {
          child.style.display = "none"; // Hide the rest
          child.classList.remove("visible");
        }
      });
      toggleButton.textContent = "Read More"; // Change button text back to "Read More"
    }
  });
});

